import React from "react";
import { general } from "../../locales/general";
import { Chip } from "../../helpers/general";
import { cardStyle } from "../../pages/Places/PlacesTable";
import Pagination from "../ui/Pagination";
import RenderTable from "../ui/RenderTable";
import BookingReviewTable from "./tables/BookingReviewsTable";

interface Props {
  userBookingReviewsData: any;
  BookingReviewsFilters: any;
  isLoading: boolean;
  handleBookingReviewsPageChange: (page: number) => void;
  handleDeleteReview: (id: string) => void;
  isDeletingReview: boolean;
}

export const BookingReviewsTab: React.FC<Props> = ({
  userBookingReviewsData,
  isLoading,
  BookingReviewsFilters,
  handleBookingReviewsPageChange,
  handleDeleteReview,
  isDeletingReview,
}) => {
  const total = userBookingReviewsData?.meta?.totalItems ?? 0;
  const totalPages = userBookingReviewsData?.meta?.totalPages ?? 0;
  const items = userBookingReviewsData?.items ?? [];

  return (
    <div>
      {/* Title + count */}
      <div className="d-flex align-items-center gap-2 mb-3 ms-4">
        <h5 className="fs-5 fw-bold mb-0">Avis des réservations</h5>
        {userBookingReviewsData?.meta && (
          <Chip tone="warning">
            {total} {total > 1 ? "avis" : "avis"}
          </Chip>
        )}
      </div>

      {/* Table */}
      <div style={{ ...cardStyle, padding: 0, overflow: "hidden" }}>
        <RenderTable
          loading={isLoading && total === 0}
          render={() =>
            total > 0 ? (
              <BookingReviewTable
                reviews={items}
                handleDeleteReview={handleDeleteReview}
                isDeletingReview={isDeletingReview}
              />
            ) : (
              <p className="text-center text-muted py-5 mb-0">
                {general.fr.noData}
              </p>
            )
          }
        />
      </div>

      {totalPages > 1 && (
        <Pagination
          currentPage={BookingReviewsFilters.page}
          onPageChange={handleBookingReviewsPageChange}
          totalCount={totalPages}
          pageSize={BookingReviewsFilters.limit}
          siblingCount={1}
        />
      )}
    </div>
  );
};
